import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/$orgSlug/')({
  component: OrgHome,
});

function OrgHome() {
  const { orgSlug } = Route.useParams();
  return <Navigate to="/$orgSlug/projects" params={{ orgSlug }} replace />;
}
